export default __webpack_public_path__ + "static/media/Padron_50Open.e0880f45.jpg";